import SupplierModifier from "../components/SupplierModifier";
import useModalForm from "../../../@hooks/useModalForm";
import SupplierModel from "../domainModel/supplier";
import service from "../../../@services";
export default function useAddSupplier() {
  const { open } = useModalForm(SupplierModifier);
  const editSupplier = (id) => {
    return new Promise((resolve, reject) => {
      open(
        (res) => {
          return new SupplierModel(res)
            .save()
            .then((res) => {
              resolve(res);
              return res;
            })
            .catch((e) => {
              reject(e);
              throw e;
            });
        },
        () => service.supplier.detail({ id }),
        {
          title: "添加供应商",
          width: 1000,
        }
      );
    });
  };
  return {
    editSupplier,
  };
}
